import i18n from "../../../i18n";

enum SchedulingStateType {
  Unknown = "Unknown",
  Active = "Active",
  Ignored = "Ignored",
  Pending = "Pending",
  Inactive = "Inactive",
  InterruptedByUser = "InterruptedByUser",
  InterruptedByError = "InterruptedByError",
  InterruptedByMaintenance = "InterruptedByMaintenance",
}

export const getSchedulingStateTypeDescription = (type: SchedulingStateType | undefined) => {
  return type ? i18n.t(`SchedulingStateType.${type}`) : null;
};

export default SchedulingStateType;
